import { useAtom } from 'jotai';
import { useCallback } from 'react';

import {
  type GlobalPropertiesTrackingProperties,
  globalPropertiesTrackAtom,
} from '$src/business/atoms/global-properties-track';

export function useGlobalPropertiesTrackAtom() {
  const [globalPropertiesTrack, setGlobalPropertiesTrackAtom] = useAtom(globalPropertiesTrackAtom);

  const onGlobalPropertiesChange = useCallback(
    (properties: GlobalPropertiesTrackingProperties) => {
      setGlobalPropertiesTrackAtom(properties);
    },
    [setGlobalPropertiesTrackAtom],
  );

  return { globalPropertiesTrack, onGlobalPropertiesChange };
}
